import React, { FC, useCallback } from "react";
import { useStyles } from "./SearchBox.style";
import { MagnifyGlass } from "@mafc/icon";
import { Input, Button, Box } from "common";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCampaigns,
  searchForCampaigns,
  setSearchTerm,
} from "store/actions/promotion.actions";
import { IState } from "store/store.interface";
import { setLocation } from "store/actions/auth.actions";
import {
  fetchBulkBundleJobs,
  searchForBulkJobs,
} from "store/actions/bulkBundleUtility.actions";
import {
  fetchBundleCampaigns,
  searchForBundleCampaigns,
} from "store/actions/bundlePromotion.actions";
import { useLocation } from "wouter";

interface IProps {
  placeholder: string;
}
const SearchBox: FC<IProps> = ({ placeholder }) => {
  const { iconWrapper, iconColor } = useStyles();
  const { searchTerm = "" } = useSelector((state: IState) => state.promotion);
  const dispatch = useDispatch();
  const onChangeSearchText = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setSearchTerm(e.target.value));
  };

  const [location] = useLocation();

  const onSearchButtonClick = useCallback(() => {
    if (location === "/cart-bundles") {
      dispatch(
        searchTerm ? searchForBundleCampaigns({ searchTerm }) : fetchBundleCampaigns()
      );
    } else if (location === "/bulk-campaign-jobs") {
      dispatch(
        searchTerm ? searchForBulkJobs({ searchTerm }) : fetchBulkBundleJobs()
      );
    } else if (location === "/") {
      dispatch(
        searchTerm ? searchForCampaigns({ searchTerm }) : fetchCampaigns()
      );
    }else if(location === "/recurring-coupons"){
      dispatch(
        searchTerm ? searchForCampaigns({ searchTerm }) : fetchCampaigns()
      );
    } else {
      /* Any unsupported page for search feature then 
    reset and redirect to coupons page */
      dispatch(setSearchTerm(""));
      dispatch(fetchCampaigns());
      dispatch(setLocation("/"));
    }
  }, [dispatch, searchTerm, location]);

  const onKeyPressHandler = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      const keyCode = event.which || event.keyCode;
      if (keyCode === 13) {
        onSearchButtonClick();
      }
    },
    [onSearchButtonClick]
  );

  return (
    <Input
      name="inputText"
      value={searchTerm}
      testId="header_search__inp"
      type="text"
      placeholder={placeholder}
      onChange={onChangeSearchText}
      autoComplete="off"
      onKeyDown={onKeyPressHandler}
      size="small"
      variant="outlined"
      width="300px"
      endAdornment={
        <Button
          data-testid="header_search__button"
          onClick={onSearchButtonClick}
          className={iconWrapper}
        >
          <Box className={iconColor}>
            <MagnifyGlass size="M" fill="#fff" />
          </Box>
        </Button>
      }
    />
  );
};

export default SearchBox;
